
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"16","fill":"none !important","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 5L11 1 1 5l10 4 10-4zm0 0v6","fill":"none"}}),_c('path',{attrs:{"d":"M5 6.6V12c0 .796.632 1.559 1.757 2.121C7.883 14.684 9.41 15 11 15c1.591 0 3.117-.316 4.243-.879C16.368 13.56 17 12.796 17 12V6.6","fill":"none"}})])
          )
        }
      }
    